export default {"src":"/_next/static/media/webinar-2.bcbafe48.svg","height":96,"width":242,"blurWidth":0,"blurHeight":0};